import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["auth.authError"],
  (error: any): any => error
);
